/** Soft mist blobs that drift across nighttime arenas. */

import { ARENA_H, ARENA_W } from "@duelgame/shared";

export interface MistBlob {
  x: number;
  y: number;
  r: number;
  vx: number;
  vy: number;
  /** Peak opacity (kept low — translucent). */
  alpha: number;
}

const BLOB_COUNT = 16;
/** How far off-arena a blob can travel before wrapping. */
const MARGIN = 120;

function freshBlob(anywhere = true): MistBlob {
  const fromLeft = Math.random() < 0.5;
  const r = 70 + Math.random() * 140;
  const dir = anywhere ? (Math.random() < 0.5 ? 1 : -1) : fromLeft ? 1 : -1;
  return {
    x: anywhere
      ? Math.random() * ARENA_W
      : fromLeft
        ? -r - Math.random() * 40
        : ARENA_W + r + Math.random() * 40,
    y: 40 + Math.random() * (ARENA_H - 80),
    r,
    vx: (18 + Math.random() * 28) * dir,
    vy: (Math.random() - 0.5) * 12,
    alpha: 0.34 + Math.random() * 0.22,
  };
}

export class NightMistField {
  blobs: MistBlob[] = [];

  clear(): void {
    this.blobs = [];
  }

  /** Seed a fresh bank of mist for a nighttime round. */
  activate(): void {
    this.blobs = Array.from({ length: BLOB_COUNT }, () => freshBlob(true));
  }

  update(dt: number): void {
    if (this.blobs.length === 0) return;
    for (const b of this.blobs) {
      b.x += b.vx * dt;
      b.y += b.vy * dt;
      // Gentle vertical bob
      b.vy += (Math.random() - 0.5) * 4 * dt;
      b.vy = Math.max(-16, Math.min(16, b.vy));

      const left = -b.r - MARGIN;
      const right = ARENA_W + b.r + MARGIN;
      const top = -b.r - MARGIN;
      const bottom = ARENA_H + b.r + MARGIN;

      if (b.x < left || b.x > right || b.y < top || b.y > bottom) {
        // Respawn drifting in from the opposite side
        Object.assign(b, freshBlob(false));
      }
    }
  }
}
